import React, { useEffect, useState } from "react";
import backBtn from "../../assets/images/backBtn.svg";
import backBtnMobile from "../../assets/images/backBtnMobile.svg";
import { useNavigate } from "react-router-dom";
import breadcrumb from "../../assets/images/breadcrumb.svg";
import { Breadcrumb } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  supportRequestAction,
  supportRequestHandler,
} from "../../redux/action/supportRequest";
import Loader from "../Loder/loader";
import { supportReqValidationSchema } from "./settingsValidation";
import { STATUS_CODE } from "../../common";
import { useCommonMessage } from "../../common/CommonMessage";
import { handleKeyPressSpace } from "../../common/CommonFunctions";
import { useTranslation } from "react-i18next";
import { ErrorMessage, Field, Form, Formik } from "formik";
import SupportRequestModal from "./SupportRequestModal";
import { getItem } from "../../common/localStorage";

const SupportRequest = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const messageApi = useCommonMessage();
  const { t } = useTranslation();

  const supportRequestSelector = useSelector((state) => state?.supportRequest);
  const supportReqData = JSON.parse(getItem("loginResponse"));

  const handleFormSubmit = (values) => {
    if (
      values?.firstName &&
      values?.lastName &&
      values?.emailId &&
      values?.description
    ) {
      let payload = {
        firstName: values?.firstName,
        lastName: values?.lastName,
        emailId: values?.emailId,
        memberId: values?.memberId,
        description: values?.description,
      };
      dispatch(supportRequestHandler(payload));
    }
  };

  useEffect(() => {
    if (supportRequestSelector?.data?.statusCode === STATUS_CODE.OK) {
      messageApi.open({
        type: "success",
        content: supportRequestSelector?.data?.message,
      });
      setIsModalOpen(true);
      dispatch(supportRequestAction.supportRequestInfoReset());
    }else if (supportRequestSelector?.message){
      messageApi.open({
        type: "error",
        content: t(supportRequestSelector?.message),
      });
      // setIsModalOpen(true);
      dispatch(supportRequestAction.supportRequestInfoReset());
    }
  }, [supportRequestSelector]);

  return (
    <>
      {supportRequestSelector?.isLoading && (
        <div className="loaderWrapper">
          <Loader loaderTransForm="loaderTransForm" />
        </div>
      )}
      <div className="py-50 mobileMargin">
        <Formik
          enableReinitialize
          initialValues={{
            firstName: supportReqData?.firstName,
            lastName: supportReqData?.lastName,
            emailId: supportReqData?.emailAddress,
            memberId: supportReqData?.caspioUserId,
            description: "",
          }}
          validationSchema={supportReqValidationSchema(t)}
          onSubmit={(values, formikBag) => {
            handleFormSubmit(values, formikBag);
          }}
        >
          {({ setErrors, setFieldValue, setFieldError, resetForm, values }) => (
            <Form>
              <div className="supportgrid mb-40 py-50 mx-auto">
                <div className="">
                  <h3 className="fs-20 mb-20">{t("First Name")}*</h3>
                  <Field
                    type="text"
                    className="inputField"
                    placeholder={t("First Name")}
                    name="firstName"
                    autoComplete="Off"
                    maxLength={40}
                    onKeyPress={handleKeyPressSpace}
                  />
                  <ErrorMessage
                    name="firstName"
                    component="div"
                    className="fs-14 error-message"
                  />
                </div>
                <div className="">
                  <h3 className="fs-20 mb-20">{t("Last Name")}*</h3>
                  <Field
                    type="text"
                    className="inputField"
                    placeholder={t("Last Name")}
                    name="lastName"
                    autoComplete="Off"
                    maxLength={40}
                    onKeyPress={handleKeyPressSpace}
                  />
                  <ErrorMessage
                    name="lastName"
                    component="div"
                    className="fs-14 error-message"
                  />
                </div>

                <div className="">
                  <h3 className="fs-20 mb-20">{t("Email Address")}*</h3>
                  <Field
                    type="text"
                    className="inputField"
                    placeholder={t("Email Address")}
                    name="emailId"
                    autoComplete="Off"
                    onKeyPress={handleKeyPressSpace}
                  />
                  <ErrorMessage
                    name="emailId"
                    component="div"
                    className="fs-14 error-message"
                  />
                </div>

                <div className="">
                  <h3 className="fs-20 mb-20">{t("Member ID")}</h3>
                  <Field
                    type="text"
                    className="inputField"
                    placeholder={t("Member ID")}
                    name="memberId"
                    autoComplete="Off"
                    onKeyPress={handleKeyPressSpace}
                  />
                  <ErrorMessage
                    name="memberId"
                    component="div"
                    className="fs-14 error-message"
                  />
                </div>
                <div>
                  <h3 className="fs-20 mb-20">{t("Description")}*</h3>
                  <Field
                    rows={5}
                    className="inputField"
                    type="textarea"
                    placeholder={t("Description")}
                    name="description"
                    maxLength="500"
                    onKeyPress={handleKeyPressSpace}
                    autoComplete="Off"
                  />
                  <ErrorMessage
                    name="description"
                    component="div"
                    className="fs-14 error-message"
                  />
                </div>
                <div className="text-center d-flex justify-center gap-10">
                  <button
                    className="saveBtn cursor-pointer w-support"
                    type="submit"
                  >
                    {t("Continue")}
                  </button>
                  {!supportReqData?.token && (
                    <button
                      className="saveBtn cursor-pointer w-support"
                      onClick={() => navigate("/login")}
                    >
                      {t("Back")}
                    </button>
                  )}
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      {isModalOpen && (
        <SupportRequestModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
        />
      )}
    </>
  );
};

export default SupportRequest;
